export const user_avatar_default = '/./assets/img/faces/img-avatar-default.png';
export const no_image = '/./assets/img/no_image.png';